var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-btn',{attrs:{"color":"#5C6065","small":"","dark":"","target":"_blank","href":_vm.appointment.googleMeetUrl}},[_c('img',{staticClass:"mr-4",attrs:{"src":require("../../../assets/google-meet.svg"),"width":"18","alt":"Google Meet"}}),_vm._v(" "+_vm._s(_vm.$t("appointment.openappointment"))+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }